import validate from "/usr/src/app/content/n3-spas-34431b0a-7733-4ace-a236-650114d4d6a6/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-34431b0a-7733-4ace-a236-650114d4d6a6/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}